module.exports = __webpack_public_path__ + "fonts/sf-medium.8296fbc2.ttf";